// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 992px) {\n.product__table ul {\n    padding-left: 22px;\n}\n}\n@media (min-width: 600px) {\n.product__table ul {\n    padding-left: 10px;\n}\n}\n@media (min-width: 1px) {\n.product__table ul {\n    padding-left: 10px;\n}\n}\n.express-checkout .product__table {\n    margin-top: 1rem;\n}\n.product-wrapper {\n  margin-top: 2rem;\n}", ""]);
// Exports
module.exports = exports;
